export default (theme) => ({
  title: {
    fontSize: '22px',
    fontWeight: 400,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    marginBottom: 10,
  },
  imgContainer: {
    width: '100%',
    height: 100,
    textAlign: 'center',
  },
  img: {
    maxWidth: '100%',
    maxHeight: '100%',
  },
  name: {
    fontSize: '18px',
    fontWeight: 500,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textAlign: 'center',
  },
  subtitle: {
    fontSize: '12px',
    color: '#646262',
    marginTop: 5,
    lineHeight: '12px',
    textAlign: 'center',
  },
  grid: {
    paddingTop: 15,
    paddingBottom: 10,
  }
});
